var map = {
	"./Bonus.svg": "./src/assets/icons/svg/Bonus.svg",
	"./add.svg": "./src/assets/icons/svg/add.svg",
	"./arrow-down.svg": "./src/assets/icons/svg/arrow-down.svg",
	"./arrowhead-left.svg": "./src/assets/icons/svg/arrowhead-left.svg",
	"./arrowhead-right.svg": "./src/assets/icons/svg/arrowhead-right.svg",
	"./balance.svg": "./src/assets/icons/svg/balance.svg",
	"./blend.svg": "./src/assets/icons/svg/blend.svg",
	"./businessHours.svg": "./src/assets/icons/svg/businessHours.svg",
	"./car.svg": "./src/assets/icons/svg/car.svg",
	"./clock.svg": "./src/assets/icons/svg/clock.svg",
	"./close.svg": "./src/assets/icons/svg/close.svg",
	"./closeX.svg": "./src/assets/icons/svg/closeX.svg",
	"./date.svg": "./src/assets/icons/svg/date.svg",
	"./delBucket.svg": "./src/assets/icons/svg/delBucket.svg",
	"./delete.svg": "./src/assets/icons/svg/delete.svg",
	"./edit.svg": "./src/assets/icons/svg/edit.svg",
	"./email.svg": "./src/assets/icons/svg/email.svg",
	"./equipment.svg": "./src/assets/icons/svg/equipment.svg",
	"./exportAdd.svg": "./src/assets/icons/svg/exportAdd.svg",
	"./exportRight.svg": "./src/assets/icons/svg/exportRight.svg",
	"./eye-close.svg": "./src/assets/icons/svg/eye-close.svg",
	"./eye-open.svg": "./src/assets/icons/svg/eye-open.svg",
	"./file.svg": "./src/assets/icons/svg/file.svg",
	"./fire.svg": "./src/assets/icons/svg/fire.svg",
	"./goTop.svg": "./src/assets/icons/svg/goTop.svg",
	"./gouxuan.svg": "./src/assets/icons/svg/gouxuan.svg",
	"./greenEdit.svg": "./src/assets/icons/svg/greenEdit.svg",
	"./guanwang.svg": "./src/assets/icons/svg/guanwang.svg",
	"./hotelsheshi.svg": "./src/assets/icons/svg/hotelsheshi.svg",
	"./hotelzhengce.svg": "./src/assets/icons/svg/hotelzhengce.svg",
	"./icon-write.svg": "./src/assets/icons/svg/icon-write.svg",
	"./icon-zhedie.svg": "./src/assets/icons/svg/icon-zhedie.svg",
	"./if-ui-delete2-white.svg": "./src/assets/icons/svg/if-ui-delete2-white.svg",
	"./inBottom.svg": "./src/assets/icons/svg/inBottom.svg",
	"./inTop.svg": "./src/assets/icons/svg/inTop.svg",
	"./jiage.svg": "./src/assets/icons/svg/jiage.svg",
	"./jian.svg": "./src/assets/icons/svg/jian.svg",
	"./jianjie.svg": "./src/assets/icons/svg/jianjie.svg",
	"./jiaotong.svg": "./src/assets/icons/svg/jiaotong.svg",
	"./jingdian.svg": "./src/assets/icons/svg/jingdian.svg",
	"./kefu-white.svg": "./src/assets/icons/svg/kefu-white.svg",
	"./kefu.svg": "./src/assets/icons/svg/kefu.svg",
	"./logo2.svg": "./src/assets/icons/svg/logo2.svg",
	"./md-spa.svg": "./src/assets/icons/svg/md-spa.svg",
	"./mengpiao.svg": "./src/assets/icons/svg/mengpiao.svg",
	"./moneny.svg": "./src/assets/icons/svg/moneny.svg",
	"./naozhong.svg": "./src/assets/icons/svg/naozhong.svg",
	"./passwordHide.svg": "./src/assets/icons/svg/passwordHide.svg",
	"./passwordShow.svg": "./src/assets/icons/svg/passwordShow.svg",
	"./person.svg": "./src/assets/icons/svg/person.svg",
	"./phone.svg": "./src/assets/icons/svg/phone.svg",
	"./pingjia.svg": "./src/assets/icons/svg/pingjia.svg",
	"./qrCode.svg": "./src/assets/icons/svg/qrCode.svg",
	"./question.svg": "./src/assets/icons/svg/question.svg",
	"./recovery.svg": "./src/assets/icons/svg/recovery.svg",
	"./relatedData.svg": "./src/assets/icons/svg/relatedData.svg",
	"./riFill-heart-fill-white.svg": "./src/assets/icons/svg/riFill-heart-fill-white.svg",
	"./right.svg": "./src/assets/icons/svg/right.svg",
	"./roadsign.svg": "./src/assets/icons/svg/roadsign.svg",
	"./save.svg": "./src/assets/icons/svg/save.svg",
	"./send.svg": "./src/assets/icons/svg/send.svg",
	"./share.svg": "./src/assets/icons/svg/share.svg",
	"./share1.svg": "./src/assets/icons/svg/share1.svg",
	"./shezhi.svg": "./src/assets/icons/svg/shezhi.svg",
	"./siteSheshi.svg": "./src/assets/icons/svg/siteSheshi.svg",
	"./star.svg": "./src/assets/icons/svg/star.svg",
	"./supplier-add.svg": "./src/assets/icons/svg/supplier-add.svg",
	"./supplier-business.svg": "./src/assets/icons/svg/supplier-business.svg",
	"./supplier-sh.svg": "./src/assets/icons/svg/supplier-sh.svg",
	"./supplier-type.svg": "./src/assets/icons/svg/supplier-type.svg",
	"./supplier-zhizi.svg": "./src/assets/icons/svg/supplier-zhizi.svg",
	"./supplier.svg": "./src/assets/icons/svg/supplier.svg",
	"./time.svg": "./src/assets/icons/svg/time.svg",
	"./video.svg": "./src/assets/icons/svg/video.svg",
	"./weixin.svg": "./src/assets/icons/svg/weixin.svg",
	"./wenhao.svg": "./src/assets/icons/svg/wenhao.svg",
	"./xuanzhong.svg": "./src/assets/icons/svg/xuanzhong.svg",
	"./xunjia.svg": "./src/assets/icons/svg/xunjia.svg",
	"./zhiding.svg": "./src/assets/icons/svg/zhiding.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";